module.exports = __webpack_public_path__ + "img/mp-boards-wires.af4f7913.jpg";